module.exports = __webpack_public_path__ + "assets/img/nb-intro-banner.8fc899eb.jpg";